import React, { CSSProperties } from "react";

export default function IconMove(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M15.1 6.1c.4.4.1.9-.3.9H13v4h4V9.2a.5.5 0 0 1 .9-.3l2.7 2.7c.2.2.2.6 0 .8L17.8 15c-.3.4-.8.1-.8-.3V13h-4v4h1.8a.5.5 0 0 1 .3.9l-2.7 2.7c-.2.2-.6.2-.8 0L9 17.8a.5.5 0 0 1 .3-.8H11v-4H7v1.8a.5.5 0 0 1-.9.3l-2.7-2.7a.5.5 0 0 1 0-.8L6 9c.4-.4.9-.1.9.3V11h4V7H9.2a.5.5 0 0 1-.3-.9l2.7-2.7c.2-.2.6-.2.8 0L15 6Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
